const Close = () => (
	<svg
		width="10"
		height="9"
		viewBox="0 0 10 9"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M6.27486 4.5L8.8619 1.95916C9.17937 1.64736 9.17937 1.14184 8.8619 0.829785L8.28695 0.265098C7.96948 -0.0466992 7.45476 -0.0466992 7.13704 0.265098L4.55 2.80594L1.96296 0.265098C1.6455 -0.0466992 1.13078 -0.0466992 0.813054 0.265098L0.238099 0.829785C-0.0793665 1.14158 -0.0793665 1.64711 0.238099 1.95916L2.82514 4.5L0.238099 7.04084C-0.0793665 7.35264 -0.0793665 7.85816 0.238099 8.17021L0.813054 8.7349C1.13052 9.0467 1.6455 9.0467 1.96296 8.7349L4.55 6.19406L7.13704 8.7349C7.4545 9.0467 7.96948 9.0467 8.28695 8.7349L8.8619 8.17021C9.17937 7.85842 9.17937 7.35289 8.8619 7.04084L6.27486 4.5Z" />
	</svg>
);

export default Close;



// WEBPACK FOOTER //
// ./src/js/app/icons/close.js